import React from "react";
import Breadcrumb from "../../../../Components/Breadcrumb/Breadcrumb";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

function BestAmbassador() {
    return (
        <>
            <Breadcrumb data="Lead Ambassador" />
            <div className="content-body">
                <div className="table-data">
                    <Tabs
                        defaultActiveKey="profile"
                        id="justify-tab-example"
                        className="mb-3 best-ambassador border-bottom-0"
                        justify
                    >
                        <Tab eventKey="home" title="State">
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Branch</th>
                                            <th>Points</th>
                                            <th>Send Notification</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Abhijit Kumar</td>
                                            <td>Kanpur</td>
                                            <td>10</td>
                                            <td>
                                                <button className="download-btn">Send</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Tab>
                        <Tab eventKey="profile" title="Region">
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Branch</th>
                                            <th>Points</th>
                                            <th>Send Notification</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Abhijit Kumar</td>
                                            <td>Kanpur</td>
                                            <td>10</td>
                                            <td>
                                                <button className="download-btn">Send</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Tab>
                        <Tab eventKey="longer-tab" title="Branch">
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Branch</th>
                                            <th>Points</th>
                                            <th>Send Notification</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Abhijit Kumar</td>
                                            <td>Kanpur</td>
                                            <td>10</td>
                                            <td>
                                                <button className="download-btn">Send</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Tab>
                        <Tab eventKey="contact" title="Pan India">
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Branch</th>
                                            <th>Points</th>
                                            <th>Send Notification</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Abhijit Kumar</td>
                                            <td>Kanpur</td>
                                            <td>10</td>
                                            <td>
                                                <button className="download-btn">Send</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Tab>
                    </Tabs>
                </div>
            </div>
        </>
    );
}

export default BestAmbassador;
